function enumKeys(obj) {
	return Object.keys(obj) as any;
}

export default enumKeys;
